var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclesDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.973 122.777C340.912 71.2722 283.707 44.9713 232.202 64.0323C180.698 83.0933 154.397 140.298 173.458 191.803C192.519 243.308 249.724 269.609 301.229 250.548C352.733 231.487 379.034 174.282 359.973 122.777Z",
    stroke: "url(#paint0_linear_77_11175)",
    strokeWidth: 22.5282
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.973 122.777C340.912 71.2722 283.707 44.9713 232.202 64.0323C180.698 83.0933 154.397 140.298 173.458 191.803C192.519 243.308 249.724 269.609 301.229 250.548C352.733 231.487 379.034 174.282 359.973 122.777Z",
    stroke: "url(#paint1_linear_77_11175)",
    strokeWidth: 22.5282
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 129.5C12 64.6066 64.6065 12 129.5 12C194.393 12 247 64.6066 247 129.5C247 194.393 194.393 247 129.5 247C64.6066 247 12 194.394 12 129.5Z",
    stroke: "url(#paint2_linear_77_11175)",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 129.5C12 64.6066 64.6065 12 129.5 12C194.393 12 247 64.6066 247 129.5C247 194.393 194.393 247 129.5 247C64.6066 247 12 194.394 12 129.5Z",
    stroke: "url(#paint3_linear_77_11175)",
    strokeWidth: 24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_11175",
    x1: 305.138,
    y1: 261.112,
    x2: 228.293,
    y2: 53.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_11175",
    x1: 305.138,
    y1: 261.112,
    x2: 228.293,
    y2: 53.4684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_11175",
    x1: 129.5,
    y1: 259,
    x2: 129.5,
    y2: 0.0000113212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_11175",
    x1: 129.5,
    y1: 259,
    x2: 129.5,
    y2: 0.0000113212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#A6C8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#0464FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesDesktop);
export default __webpack_public_path__ + "static/media/circles-desktop.72a94adc9d74112aa9aaaec8b5f7c8e3.svg";
export { ForwardRef as ReactComponent };